<template>
  <ECharts :options="countryChartOptions" />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import echarts from 'echarts';
import ECharts from 'vue-echarts/components/ECharts.vue';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import _ from 'lodash';

@Component({
  components: { ECharts }
})
export default class CountryEchart extends Vue {
  @Prop(Object) data;
  @Prop(String) titleText;
  @Prop(Object) seriesName;

  provinces = []

  mounted() {
    // 引入中国地图数据
    const china = require('echarts/map/json/china.json');
    echarts.registerMap('china', china);
    this.provinces = china.features.map(ele => ele.properties.name).concat('南海诸岛');
  }

  get seriesData() {
    return this.provinces.map(province => {
      return {
        name: province,
        value: _.result(_.find(this.data, (item) => province.includes(item.name) || item.name.includes(province)), 'value') || 0
      };
    })
  }

  get countryChartOptions() {
    return ({
      tooltip: {
        trigger: 'item',
        formatter: '{a}<br/>{b}：{c}'
      },
      title: {
        text: this.titleText,
        left: '0',
        top: '5%',
        textStyle: {
          color: '#ccc'
        }
      },
      visualMap: {
        left: '0',
        min: 0,
        max: 100,
        inRange: {
          color: ['#f7fffa', '#98efbc', '#79e0a4', '#5cca8a', '#4db779', '#43a56b', '#3a945f']
        },
        text: ['高', '低'],
        calculable: true
      },
      toolbox: {
        show: true,
        left: 'right',
        top: '5%',
        feature: {
          dataView: { readOnly: true },
          saveAsImage: {}
        }
      },
      series: [
        {
          name: this.seriesName,
          type: 'map',
          roam: true,
          map: 'china',
          emphasis: {
            lable: { show: true }
          },
          data: this.seriesData,
        }
      ]
    })
  }
}
</script>
